import React from "react";
import { displayCurrencySymbol, displayDate } from "../../utils/Utils";
import moment from "moment-timezone";

const FormGroupStaticAmount = ({
    label,
    value,
    currencyCode,
    currencySymbol,
    currencyStringValue,
    preferredDateFormat,
    preTimeZoneKey,
    easyEdit
}) => {
    const timezone = preTimeZoneKey || "Asia/Calcutta";
    const dateFormat = preferredDateFormat || 'YYYY-MM-DD';

    const formatValue = () => {
        if (!value) return '';

        switch (label) {
            case 'Deal Amount':
            case 'Price':
            case 'Monthly Target':
            case 'Tax':
                return displayCurrencySymbol(value, currencyCode, currencySymbol, currencyStringValue);

            case 'Deal Probability':
                return `${value} %`;

            case 'Expected Closing Date':
            case 'Valid Until':
                if (value === 'N/A' || value === '0000-00-00 00:00:00') return 'N/A';
                const formattedDate = moment.utc(value).tz(timezone).format(dateFormat);
                return displayDate(formattedDate, 'half');

            default:
                return value;
        }
    };

    const displayClass = value === 'N/A' ? 'text-secondary' : '';

    return (
        <div className={`form-group-static ${easyEdit ? 'easy-edit' : ''}`}>
            <label className="control-label-static">{label}</label>
            <p className={`form-control-static ${displayClass}`}>
                {formatValue()}
            </p>
        </div>
    );
};
export default FormGroupStaticAmount;